'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this._handleChange = function (e) {
      _this.setState((0, _defineProperty3.default)({}, e.target.name, e.target.value));
    };

    _this._onSubmit = function () {
      var _this$state = _this.state,
          username = _this$state.username,
          password = _this$state.password;

      if (username !== '' && password !== '') {
        var credentials = { username: username.trim(), password: password.trim() };
        if (_this.props.onSubmit) _this.props.onSubmit(credentials);
      }
    };

    _this.state = {
      email: '',
      password: '',
      uatmode: false
    };
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var BTN_SIZES = _components.ENTERPRISE_BUTTON_SIZES;
      var BTN_TYPES = _components.ENTERPRISE_BUTTON_TYPES;
      var styles = require('./Login.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(
          'div',
          { className: styles.loginForm },
          _react2.default.createElement(
            'h2',
            { className: styles.title },
            'Sign In'
          ),
          _react2.default.createElement(
            'label',
            { htmlFor: 'username', className: styles.label },
            'User Name'
          ),
          _react2.default.createElement(_components.EnterpriseInput, {
            id: 'username',
            name: 'username',
            type: 'text',
            size: _components.ENTERPRISE_INPUT_SIZES.LARGE,
            onChange: this._handleChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'password', className: styles.label },
            'Password'
          ),
          _react2.default.createElement(_components.EnterpriseInput, {
            id: 'password',
            name: 'password',
            type: 'password',
            size: _components.ENTERPRISE_INPUT_SIZES.LARGE,
            onChange: this._handleChange
          }),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: styles.button,
              size: BTN_SIZES.BIG,
              type: BTN_TYPES.PRIMARY,
              onClick: this._onSubmit
            },
            'SIGN IN'
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class.propTypes = {
  onSubmit: _react.PropTypes.func
}, _temp);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.jsx
// module id = 1457
// module chunks = 0